var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VWrapper',{attrs:{"title":"salesOverview.index","sub-title":"common.overview"}},[_c('SalesOverviewTable',{ref:"table",staticClass:"mt-2",attrs:{"total":_vm.total,"items":_vm.items,"venue":_vm.venue,"show-foodspot":_vm.isDeanAndDavid},on:{"export":_vm.exportSales,"search":_vm.onSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }